import cloudinary from 'cloudinary-core';

export const getLocationImage = (url, isMobile) => {
  if (!url) return '';
  const cl = new cloudinary.Cloudinary({
    cloud_name: 'letsdothiscom',
    secure: true,
  });

  const width = isMobile ? 150 : 300;

  return cl.url(url.substring(url.indexOf('category-assets')), {
    width,
    fetchFormat: 'auto',
    crop: 'scale',
  });
};
